import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerLocalidaXProvincia = async (provincia) => {
    const params = {
        hash: await getApiHash(),
        provincia: provincia
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getlocalidadesjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.localidades.sort((a, b) => a.localeCompare(b))
        }).catch(function (error) {
            return error;
    });
};

export default obtenerLocalidaXProvincia;
   